import script from "./ProgressDial.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressDial.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressDial.vue?vue&type=style&index=0&id=646f3fe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646f3fe3"]])

export default __exports__